import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReportEditor from './report-editor.reducer';

export interface ReportEditorDomainState {
  [fromReportEditor.reportEditorFeatureKey]: fromReportEditor.State;
}

export const selectReportEditorState = createFeatureSelector<fromReportEditor.State>(
  fromReportEditor.reportEditorFeatureKey
);

export const selectEditorLayout = createSelector(selectReportEditorState, (state) => state.editorLayout);

export const selectSelectedQueryToken = createSelector(selectReportEditorState, (state) => state.selectedQueryToken);

export const selectImportDatasetResponse = createSelector(
  selectReportEditorState,
  (state) => state.importDatasetResponse
);
